import { Component, CSSProperties } from 'react'
import { Text } from '@lmc/ui-kit'

interface CarePlanActionProps {
  title: string
  text: string
}

class CarePlanAction extends Component<CarePlanActionProps> {
  render() {
    const { title, text } = this.props
    return (
      <div style={styles.container}>
        <Text style={styles.title}>{title}</Text>
        <p style={styles.text}>{text}</p>
      </div>
    )
  }
}

const styles: Record<string, CSSProperties> = {
  container: {
    paddingBottom: 30,
  },
  title: {}, // Assuming you want to keep this for possible future styling
  text: {
    marginTop: 0,
  },
}

export default CarePlanAction
